// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared UI for Packers / Drivers / Dispatchers management pages */

.staff-mgmt-page {
  min-height: 100vh;
  background: #fff;
}

.staff-mgmt-page .page {
  padding: 67px 16px 24px;
  box-sizing: border-box;
}

.staff-mgmt-page .driver-table {
  width: 100%;
}

.staff-mgmt-page .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 14px;
  padding: 0;
  flex-wrap: nowrap;
}

.staff-mgmt-page .header h2 {
  margin: 0;
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.staff-mgmt-page .moreActions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  flex-wrap: nowrap;
}

.staff-mgmt-page .actual-search-wrapper {
  width: 190px;
  height: 36px;
  margin: 0;
  padding: 0;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-sizing: border-box;
}

.staff-mgmt-page .actual-search-wrapper form,
.staff-mgmt-page .actual-search-wrapper .input-group {
  width: 100%;
  height: 100%;
}

.staff-mgmt-page .actual-search-wrapper .form-control {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  color: #0f172a;
  font-size: 13px;
  background: transparent;
  border: 0 !important;
  border-radius: 6px;
  outline: 0;
  box-shadow: none !important;
  box-sizing: border-box;
}

.staff-mgmt-page .actual-search-wrapper:focus-within {
  border-color: #79c6e9;
  box-shadow: 0 0 0 2px rgba(121, 198, 233, 0.16);
}

.staff-mgmt-page .newDD {
  margin: 0;
}

.staff-mgmt-page .staff-create-btn {
  width: 40px;
  height: 36px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
  background: #79c6e9;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.staff-mgmt-page .staff-create-btn:hover {
  background: #5dbbe6;
}

.staff-mgmt-page .tabs {
  display: flex;
  margin: 0 0 8px;
}

.staff-mgmt-page .tabs button {
  padding: 7px 2px;
  color: #64748b;
  font-size: 13px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
}

.staff-mgmt-page .tabs button.active {
  color: #0f172a;
  border-bottom-color: #79c6e9;
}

.staff-mgmt-page .DispatcherTable,
.staff-mgmt-page .DriverTable {
  width: 100%;
  margin: 0;
  background: #fff;
  border-collapse: collapse;
}

.staff-mgmt-page .DispatcherTable .Dth,
.staff-mgmt-page .DriverTable .Dth {
  padding: 12px 14px !important;
  color: #334155;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 1.4;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb !important;
}

.staff-mgmt-page .DispatcherTable td,
.staff-mgmt-page .DriverTable td {
  padding: 12px 14px !important;
  color: #475569;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 1.45;
  border-bottom: 1px solid #f1f5f9 !important;
}

.staff-mgmt-page .DispatcherTable tbody tr:hover,
.staff-mgmt-page .DriverTable tbody tr:hover {
  background: #f8fbfd;
}

.staff-mgmt-page .clickable-name {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #0f172a !important;
  font-weight: 600 !important;
  cursor: pointer;
}

.staff-mgmt-page .circular-initial {
  width: 32px;
  height: 32px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #075985;
  font-size: 13px;
  font-weight: 700;
  background: #e0f2fe;
  border-radius: 50%;
}

.staff-mgmt-page .three-dots {
  min-width: 38px;
  height: 30px;
  padding: 0 10px;
  color: #475569;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
}

.staff-mgmt-page .three-dots:hover {
  color: #0f172a;
  background: #f8fafc;
  border-color: #cbd5e1;
}

.staff-mgmt-page .staff-empty-state {
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f1f5f9;
}

.staff-mgmt-page .staff-empty-state .center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100%;
  gap: 0;
  color: #000;
}

.staff-mgmt-page .staff-empty-state .icon-wrapper {
  background-color: #07a6ef;
  padding: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  margin-top: 15px;
  animation: staffEmptyFadeInUp 0.4s ease-in-out;
}

.staff-mgmt-page .staff-empty-state .icon {
  width: auto;
  height: auto;
  font-size: 25px;
  color: #000;
}

.staff-mgmt-page .staff-empty-state .noOrdersMsg {
  color: #000;
  font-size: 20px;
  font-weight: normal;
  animation: staffEmptyFadeInUp 0.4s ease-in-out;
}

@keyframes staffEmptyFadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 700px) {
  .staff-mgmt-page .page {
    padding: 54px 8px 16px;
  }

  .staff-mgmt-page .header {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .staff-mgmt-page .header h2 {
    font-size: 20px;
  }

  .staff-mgmt-page .moreActions {
    width: 100%;
  }

  .staff-mgmt-page .actual-search-wrapper {
    flex: 1 1;
    width: auto;
  }

  .staff-mgmt-page .driver-table {
    overflow-x: auto;
  }

  .staff-mgmt-page .DispatcherTable,
  .staff-mgmt-page .DriverTable {
    min-width: 680px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/StaffMgmt.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,MAAM;EACN,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/* Shared UI for Packers / Drivers / Dispatchers management pages */\n\n.staff-mgmt-page {\n  min-height: 100vh;\n  background: #fff;\n}\n\n.staff-mgmt-page .page {\n  padding: 67px 16px 24px;\n  box-sizing: border-box;\n}\n\n.staff-mgmt-page .driver-table {\n  width: 100%;\n}\n\n.staff-mgmt-page .header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 14px;\n  padding: 0;\n  flex-wrap: nowrap;\n}\n\n.staff-mgmt-page .header h2 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.staff-mgmt-page .moreActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  flex-wrap: nowrap;\n}\n\n.staff-mgmt-page .actual-search-wrapper {\n  width: 190px;\n  height: 36px;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  box-sizing: border-box;\n}\n\n.staff-mgmt-page .actual-search-wrapper form,\n.staff-mgmt-page .actual-search-wrapper .input-group {\n  width: 100%;\n  height: 100%;\n}\n\n.staff-mgmt-page .actual-search-wrapper .form-control {\n  width: 100%;\n  height: 100%;\n  padding: 0 10px;\n  color: #0f172a;\n  font-size: 13px;\n  background: transparent;\n  border: 0 !important;\n  border-radius: 6px;\n  outline: 0;\n  box-shadow: none !important;\n  box-sizing: border-box;\n}\n\n.staff-mgmt-page .actual-search-wrapper:focus-within {\n  border-color: #79c6e9;\n  box-shadow: 0 0 0 2px rgba(121, 198, 233, 0.16);\n}\n\n.staff-mgmt-page .newDD {\n  margin: 0;\n}\n\n.staff-mgmt-page .staff-create-btn {\n  width: 40px;\n  height: 36px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #0f172a;\n  background: #79c6e9;\n  border: 0;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.staff-mgmt-page .staff-create-btn:hover {\n  background: #5dbbe6;\n}\n\n.staff-mgmt-page .tabs {\n  display: flex;\n  margin: 0 0 8px;\n}\n\n.staff-mgmt-page .tabs button {\n  padding: 7px 2px;\n  color: #64748b;\n  font-size: 13px;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n}\n\n.staff-mgmt-page .tabs button.active {\n  color: #0f172a;\n  border-bottom-color: #79c6e9;\n}\n\n.staff-mgmt-page .DispatcherTable,\n.staff-mgmt-page .DriverTable {\n  width: 100%;\n  margin: 0;\n  background: #fff;\n  border-collapse: collapse;\n}\n\n.staff-mgmt-page .DispatcherTable .Dth,\n.staff-mgmt-page .DriverTable .Dth {\n  padding: 12px 14px !important;\n  color: #334155;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  line-height: 1.4;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  background: #f8fafc;\n  border-bottom: 1px solid #e5e7eb !important;\n}\n\n.staff-mgmt-page .DispatcherTable td,\n.staff-mgmt-page .DriverTable td {\n  padding: 12px 14px !important;\n  color: #475569;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: 1.45;\n  border-bottom: 1px solid #f1f5f9 !important;\n}\n\n.staff-mgmt-page .DispatcherTable tbody tr:hover,\n.staff-mgmt-page .DriverTable tbody tr:hover {\n  background: #f8fbfd;\n}\n\n.staff-mgmt-page .clickable-name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #0f172a !important;\n  font-weight: 600 !important;\n  cursor: pointer;\n}\n\n.staff-mgmt-page .circular-initial {\n  width: 32px;\n  height: 32px;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #075985;\n  font-size: 13px;\n  font-weight: 700;\n  background: #e0f2fe;\n  border-radius: 50%;\n}\n\n.staff-mgmt-page .three-dots {\n  min-width: 38px;\n  height: 30px;\n  padding: 0 10px;\n  color: #475569;\n  font-size: 16px;\n  line-height: 1;\n  text-align: center;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.staff-mgmt-page .three-dots:hover {\n  color: #0f172a;\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.staff-mgmt-page .staff-empty-state {\n  min-height: 40vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid #f1f5f9;\n}\n\n.staff-mgmt-page .staff-empty-state .center-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100px;\n  width: 100%;\n  gap: 0;\n  color: #000;\n}\n\n.staff-mgmt-page .staff-empty-state .icon-wrapper {\n  background-color: #07a6ef;\n  padding: 10px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 15px;\n  margin-top: 15px;\n  animation: staffEmptyFadeInUp 0.4s ease-in-out;\n}\n\n.staff-mgmt-page .staff-empty-state .icon {\n  width: auto;\n  height: auto;\n  font-size: 25px;\n  color: #000;\n}\n\n.staff-mgmt-page .staff-empty-state .noOrdersMsg {\n  color: #000;\n  font-size: 20px;\n  font-weight: normal;\n  animation: staffEmptyFadeInUp 0.4s ease-in-out;\n}\n\n@keyframes staffEmptyFadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 700px) {\n  .staff-mgmt-page .page {\n    padding: 54px 8px 16px;\n  }\n\n  .staff-mgmt-page .header {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .staff-mgmt-page .header h2 {\n    font-size: 20px;\n  }\n\n  .staff-mgmt-page .moreActions {\n    width: 100%;\n  }\n\n  .staff-mgmt-page .actual-search-wrapper {\n    flex: 1;\n    width: auto;\n  }\n\n  .staff-mgmt-page .driver-table {\n    overflow-x: auto;\n  }\n\n  .staff-mgmt-page .DispatcherTable,\n  .staff-mgmt-page .DriverTable {\n    min-width: 680px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
